import { OuterLink } from '@shared/ui/GenericLink';
import { Link } from '@shared/ui/Link';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const ModalBodyGratitudeHandToHand = () => {
  const { t } = useTranslation();

  // const link = `/documents/hand-to-hand-help-manual.pdf`;

  return (
    <div className="text-xs font-light">
      {/* <OuterLink to={link} className="text-shamrock hover:underline text-bold">
        {t('hand-to-hand-instruction')}
      </OuterLink>
      <br />
      <br /> */}
      <p dangerouslySetInnerHTML={{ __html: t('hand-to-hand-instruction-description-2') }} />
      <br />
    </div>
  );
};
